module.exports = __webpack_public_path__ + "static/img/advantage.13ab8284.png";